export default __webpack_public_path__ + "static/media/shopify-masthead.f84d8a0a.jpg";